// extracted by mini-css-extract-plugin
module.exports = {"copyright":"copyright-module--copyright--3EZ3i"};